import {Pipe, PipeTransform} from '@angular/core';
import {AssetType} from "@services";

@Pipe({
    name: 'assetType',
    standalone: true
})
export class AssetTypePipe implements PipeTransform {
    transform(value: AssetType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case AssetType.TwoWayRadio: return "2 Way Radio's";
            case AssetType.ChargerConventional: return "Charger-Conventional";
            case AssetType.ChargerEastPenn: return "Charger-East Penn";
            case AssetType.ChargerPosi: return "Charger-Posi";
            case AssetType.ChargerRadioShuttle: return "Charger-Radio Shuttle";
            case AssetType.ChargerShuntTruck: return "Charger-Shunt Truck";
            case AssetType.ClampLayerAttach: return "Clamp - Layer Attach";
            case AssetType.DesktopComputer: return "Desktop Computer";
            case AssetType.HandheldScanner: return "Handheld Scanner";
            case AssetType.LaptopChargingBlock: return "Laptop Charging Block";
            case AssetType.LaptopComputer: return "Laptop Computer";
            case AssetType.MhBtS: return "MH BT's";
            case AssetType.MhCounterBalance: return "MH Counter Balance";
            case AssetType.MhCounterBalanceLayPick: return "MH Counter Balance - LAY PICK";
            case AssetType.MhReach: return "MH Reach";
            case AssetType.MhWalkies: return "MH Walkies";
            case AssetType.MheBatteries: return "MHE Batteries";
            case AssetType.MobileLabelPrinter: return "Mobile Label Printer";
            case AssetType.OfficeDocPrinters: return "Office Doc Printers";
            case AssetType.OfficeLabelPrinters: return "Office Label Printers";
            case AssetType.Palletizer: return "Palletizer";
            case AssetType.PhotoCopyMachine: return "Photo Copy Machine";
            case AssetType.RfScanGuns: return "RF Scan Guns";
            case AssetType.RadioShuttleBatteries: return "Radio Shuttle Batteries";
            case AssetType.RadioShuttleCart: return "Radio Shuttle Cart";
            case AssetType.RadioShuttleRemote: return "Radio Shuttle Remote";
            case AssetType.ScissorLift: return "Scissor Lift";
            case AssetType.Scrubbers: return "Scrubbers";
            case AssetType.ShuntTruck: return "Shunt Truck";
            case AssetType.SlipSheetAttach: return "Slip Sheet Attach";
            case AssetType.TvSets: return "TV Sets";
            case AssetType.TabletComputers: return "Tablet Computers";
            case AssetType.WrapMachine: return "Wrap Machine";
            default: return value;
        }
    }
}

